/**
 * Centralised dayjs locale wiring. Importing this module:
 *  - registers the Polish / English / German dayjs locale bundles, and
 *  - keeps dayjs's global locale in sync with i18next so callers can use
 *    plain `dayjs(...)` without per-callsite `.locale("pl")` calls.
 *
 * Import once from `main.tsx` (alongside the i18n bootstrap). The Polish
 * default is preserved when i18n hasn't initialised yet.
 */

import dayjs from "dayjs";
import "dayjs/locale/pl";
import "dayjs/locale/en-gb";
import "dayjs/locale/de";

import i18n, { resolveAppLanguage, type SupportedLocale } from "@/lib/i18n";

const DAYJS_LOCALE: Record<SupportedLocale, string> = {
  pl: "pl",
  en: "en-gb",
  de: "de",
};

function syncDayjsLocale() {
  dayjs.locale(DAYJS_LOCALE[resolveAppLanguage()]);
}

syncDayjsLocale();
i18n.on("languageChanged", syncDayjsLocale);
